(function () {
  // strips the stale engraving properties from a main-product line
  function cleanLine(item) {
    var cleanedProps = Object.assign({}, item.properties);
    delete cleanedProps['Base Text'];
    delete cleanedProps['_engrave_ref'];

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: item.line,
        quantity: item.quantity,
        properties: cleanedProps,
      }),
    });
  }

  // a main product line is "orphaned" if it carries an engraving ref but no
  // addon line in the cart shares that same ref anymore
  function findOrphans(cart) {
    var activeAddonRefs = new Set();

    cart.items.forEach(function (item) {
      var ref = item.properties && item.properties._engrave_ref;
      var hasBaseText = item.properties && item.properties['Base Text'];
      if (ref && !hasBaseText) activeAddonRefs.add(ref);
    });

    var orphans = [];
    cart.items.forEach(function (item, index) {
      var ref = item.properties && item.properties._engrave_ref;
      var hasBaseText = item.properties && item.properties['Base Text'];
      if (ref && hasBaseText && !activeAddonRefs.has(ref)) {
        orphans.push(Object.assign({}, item, { line: index + 1 }));
      }
    });

    return orphans;
  }

  // checks the cart and cleans any orphaned engraving. Resolves true if
  // something was actually cleaned, false if the cart was already fine.
  function cleanOrphans() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var orphans = findOrphans(cart);
        if (!orphans.length) return false;

        var chain = Promise.resolve();
        orphans.forEach(function (item) {
          chain = chain.then(function () { return cleanLine(item); });
        });
        return chain.then(function () { return true; });
      });
  }

  // ═══════ /cart page — reload after fixing (simplest way to get the
  // total/footer correct too, since nothing there needs to stay "live") ═══════
  function handleCartPageRemoval() {
    cleanOrphans()
      .catch(function () {})
      .finally(function () {
        window.location.reload();
      });
  }

  // ═══════ drawer — live refresh, no reload. Mirrors Dawn's own
  // CartItems.onCartUpdate() drawer branch exactly (same two selectors,
  // same section_id fetch), so it repaints exactly the way Dawn already
  // knows how to, just triggered by us once the fix is actually done. ═══════
  function refreshDrawer() {
    return fetch('/cart?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (selector) {
          var targetElement = document.querySelector(selector);
          var sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        });
      });
  }

  function handleDrawerRemoval() {
    cleanOrphans()
      .then(function (didClean) {
        // only worth a refresh if we actually changed something — Dawn's
        // own refresh already handled a plain removal correctly on its own
        if (didClean) return refreshDrawer();
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var removeBtn = event.target.closest && event.target.closest('cart-remove-button');
    if (!removeBtn) return;

    if (removeBtn.closest('cart-items')) {
      // give the removal's own request time to persist first
      setTimeout(handleCartPageRemoval, 900);
    } else if (removeBtn.closest('cart-drawer-items')) {
      setTimeout(handleDrawerRemoval, 900);
    }
  }, true);
})();